import { Box, IconButton, Popover, Typography } from "@mui/material";
import React, { useState } from "react";
import verticalMenu from "../../../../public/assets/icons/verticalMenu.svg";

const menuOptions = [
  { name: "Move up", value: "up" },
  { name: "Move down", value: "down" },
  { name: "Move to top", value: "top" },
  { name: "Move to bottom", value: "bottom" },
];

export const RankMenu = (props: any) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelection = (value) => {
    let index;
    switch (value) {
      case "up":
        index = props?.node?.rowIndex - 1;
        break;
      case "down":
        index = props?.node?.rowIndex + 1;
        break;
      case "top":
        index = 0;
        break;
      case "bottom":
        index = -1;
        break;
    }
    props?.handleRankSelection(props?.node?.rowIndex, index);
  };

  const showOption = (value) => {
    let show = true;
    switch (value) {
      case "up":
        show = !props?.node?.firstChild;
        break;
      case "down":
        show = !props?.node?.lastChild;
        break;
      case "top":
        show = !props?.node?.firstChild;
        break;
      case "bottom":
        show = !props?.node?.lastChild;
        break;
    }
    return show;
  };

  return (
    <div>
      <IconButton
        onClick={handleMenuClick}
        disableRipple={true}
        style={{
          width: "50px",
          verticalAlign: "top" 
        }}
      >
        <img
          style={{ cursor: "pointer" }}
          src={verticalMenu}
          alt="menu"
        />
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box
          sx={{
            minHeight: "50px",
            marginTop: "30px",
            marginLeft: "30px",
            marginRight: "30px",
            height: "fit-content",
            width: "fit-content",
          }}
        >
          {menuOptions.map((option) => {
            return showOption(option?.value) && (
              <Typography
                onClick={() => handleSelection(option?.value)}
                paddingBottom={"30px"}
                style={{ cursor: "pointer" }}
                key={option?.value}
              >
                {option?.name}
              </Typography>
            );
          })}
        </Box>
      </Popover>
    </div>
  );
};
